import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DepartmentItemProps } from "apis";
import { PaginationProps } from "utils/types/API";

export interface DepartmentState {
    loading: boolean;
    list: {
        data: DepartmentItemProps[];
        options: DepartmentItemProps[];
        pagination?: PaginationProps;
    };
    item: {
        data?: DepartmentItemProps;
    };
}

const initialState: DepartmentState = {
    loading: false,
    list: {
        data: [],
        options: []
    },
    item: {
    }
};

interface IndexProps {
    data: DepartmentItemProps[];
    pagination?: PaginationProps;
}
interface ItemProps {
    data?: DepartmentItemProps;
}
export const departmentSlice = createSlice({
    name: "department",
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
        },
        endLoading: (state) => {
            state.loading = false;
        },
        index: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.data = action.payload.data;
            state.list.pagination = action.payload.pagination;
        },
        options: (state, action: PayloadAction<IndexProps>) => {
            state.loading = false;
            state.list.options = action.payload.data;
        },
        find: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        create: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
        },
        update: (state, action: PayloadAction<ItemProps>) => {
            state.loading = false;
            state.item.data = action.payload.data;
            state.list.data = state.list.data.map(item => item.id === action.payload.data?.id ? action.payload.data : item);
        },
    },
});

export const { loading, endLoading, index, options, find, create, update } = departmentSlice.actions;
export default departmentSlice.reducer;
